import { useState, useCallback } from 'react';

export type SafeAreaKind = '4:3' | '16:9';
export type SafeAreaSelection = readonly SafeAreaKind[];

const SAFE_AREA_KEY = 'player.safeAreas';
const VALID_SAFE_AREAS: readonly string[] = ['4:3', '16:9'];

function loadSavedSafeAreas(): SafeAreaSelection {
  try {
    const raw = localStorage.getItem(SAFE_AREA_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is SafeAreaKind => VALID_SAFE_AREAS.includes(v as string));
  } catch {
    // localStorage unavailable or invalid JSON
  }
  return [];
}

export function useVideoOverlays() {
  const [activeMatte, setActiveMatte] = useState<number | null>(null);
  const [activeSafeAreas, setActiveSafeAreasState] = useState<SafeAreaSelection>(loadSavedSafeAreas);

  const toggleSafeArea = useCallback((kind: SafeAreaKind) => {
    setActiveSafeAreasState((prev) => {
      const next = prev.includes(kind)
        ? prev.filter((k) => k !== kind)
        : [...prev, kind];
      try {
        if (next.length === 0) {
          localStorage.removeItem(SAFE_AREA_KEY);
        } else {
          localStorage.setItem(SAFE_AREA_KEY, JSON.stringify(next));
        }
      } catch {
        // localStorage unavailable
      }
      return next;
    });
  }, []);

  return { activeMatte, setActiveMatte, activeSafeAreas, toggleSafeArea };
}
